<template>
  <tg-layout>
    <tg-panel :title="$t('page.rule.title')">
      <el-image :src="ruleImage"></el-image>
    </tg-panel>
  </tg-layout>
</template>


<script>
import TgLayout from "@/layout/TgLayout";
import TgPanel from "@/components/panel/TgPanel";

import url, { currentUrl } from "@/config/url";

export default {
  components: {
    TgLayout,
    TgPanel,
  },
  computed: {
    ruleImage() {
      return currentUrl(url.rule + "?lang=" + this.$store.state.app.lang.key);
    },
  },
};
</script>